import React, {useEffect} from 'react';
import DataTable from "react-data-table-component";
import icPrint from '../assets/icons/ic-card-print.svg';
import icProcess from '../assets/icons/ic-card-process.svg';
import {
    FILTER_INTERVAL,
    FILTER_INTERVAL_DPK,
    FILTER_JENIS_LAYANAN,
    FILTER_JENIS_PENGGUNA_LAYANAN,
    FILTER_STATUS, FILTER_STATUS_SLK, GET_STATUS_CATEGORY,
    PENGAJUAN
} from "../Constanta";
import {AuthContext, DataContext} from "../Context";
import {DashboardChartData, SlkPile, TableColumnHeaderMapping} from "../components/dashboard-components";
import {MapToChart, MapToCounter, MapToTable, translateRequestStatus} from "../Services";
import {day, month, year} from "../util";
import {Bar} from "react-chartjs-2";

const DashboardPelayanan = () => {
    const [dataContext, dataState] = React.useContext(DataContext);
    const [authContext, loginState] = React.useContext(AuthContext);

    const [data, setData] = React.useState({
        DPK_cardCategory: 'NEW',
        DPK_interval: 'week',
        DPK_data: {
            label: [],
            data: []
        },
        status_category: [],
        DP_data: [],
        DP_initialData: [],
        DP_search: '',
        DP_filter: {
            requestType: 'all',
            createdDate: 'all',
            category: 'all',
            requestStatus: 'ALL'
        },
        loginInfo: 'pelayanan'
    });

    useEffect(() => {
        setTimeout(async () => {
                await FetchCustomerData('GET', null);
                await FetchStatusCategory();
            }, 1000
        );

    }, []);

    const FetchCustomerData = async (method, requestBody) => {
        let url = PENGAJUAN;
        let payload;
        let token = await localStorage.getItem('userToken')
        payload = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: requestBody ?
                JSON.stringify({requestBody})
                : null
        };
        if (token) {
            fetch(url, payload).then((result) => {
                if (result.status === 200) {
                    result.json().then(resultData => {
                        dataContext.setDataPengajuanCustomer(resultData);
                        dataContext.setCustomerData(MapToChart(resultData));
                        dataContext.setCustomerDataTable(MapToTable(resultData));
                        dataContext.setTotalCardCounter(MapToCounter(MapToTable(resultData)));
                        let chartData = updateChartData(chartLabelSelection(MapToChart(resultData), data.DPK_cardCategory, data.DPK_interval));
                        setData({
                            ...data,
                            DP_data: MapToTable(resultData),
                            DP_initialData: MapToTable(resultData),
                            DPK_data: {label: chartData.chartLabel, data: chartData.chartData}
                        })
                    })
                } else {
                    authContext.signOut();
                }
            });
        } else {
            await authContext.signOut();
        }
    }

    const FetchStatusCategory = async () => {

        let token = await localStorage.getItem('userToken');
        let payload = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        };
        if (token) {
            fetch(GET_STATUS_CATEGORY, payload).then((result) => {
                if (result.status === 200) {
                    result.json().then(resultData => {
                        dataContext.setStatusCategory(resultData)
                        setData({
                            ...data,
                            statusCategory: resultData
                        })
                    })
                } else {
                    authContext.signOut();
                }
            });
        } else {
            await authContext.signOut();
        }
    }

    const chartLabelSelection = (objectToFilter, pileFilter, dateFilter) => {
        let currentData = objectToFilter.filter(x => x.cardCategory.toUpperCase().includes(pileFilter));
        let filteredDate;
        switch (dateFilter) {
            case 'week':
                filteredDate = currentData.filter(x => x.createDate.split('-')[2] <= day || x.createDate.split('-')[2] >= day - 7);
                break;
            case 'month':
                filteredDate = currentData.filter(x => x.createDate.split('-')[1] === month);
                break;
            case 'year':
                filteredDate = currentData.filter(x => x.createDate.split('-')[0] === year);
                break;
            default:
                filteredDate = currentData;
                break;
        }
        return filteredDate;
    }

    const updateChartData = (object) => {
        let chartLabel = [];
        let chartData = [];
        let counts = object.reduce((p, c) => {
            let date = c.createDate;
            if (!p.hasOwnProperty(date)) {
                p[date] = 0;
            }
            p[date]++;
            return p;
        }, {});

        Object.keys(counts).forEach(key => {
            chartLabel.push(key)
            chartData.push(counts[key]);
        });

        return {chartLabel, chartData};
    }

    const onChangeDPKPile = (filter) => {
        let chartData = updateChartData(chartLabelSelection(dataState.customerDataChart, filter, data.DPK_interval));
        setData({
            ...data,
            DPK_cardCategory: filter,
            DPK_data: {label: chartData.chartLabel, data: chartData.chartData}
        })
    }

    const onChangeDPKInterval = (interval) => {
        let chartData = updateChartData(chartLabelSelection(dataState.customerDataChart, data.DPK_cardCategory, interval));
        setData({
            ...data,
            DPK_interval: interval,
            DPK_data: {label: chartData.chartLabel, data: chartData.chartData}
        })
    }

    const selectedClassName = (selected) => {
        return data.DPK_cardCategory === selected ? "dpk-pile" : "dpk-pile-unselected";
    }

    const mapSLKPile = (components, status) => {
        if (components === 'icons') {

        }
    }

    const onSearchDaftarPelanggan = (event) => {
        if (event.key === 'Enter') {
            if (data.DP_search) {
                setData({
                    ...data,
                    DP_data: data.DP_initialData.filter(x => x.nik.includes(data.DP_search) || x.fullName.includes(data.DP_search)),
                })
            } else {
                setData({
                    ...data,
                    DP_data: data.DP_initialData,
                })
            }
        }
    }

    const onChangeDPFilter = (filterName, filterValue) => {
        let newState = data.DP_filter;
        let mutableData = data.DP_initialData;
        let filteredData = [];
        switch (filterName) {
            case 'category':
                if (filterValue.toUpperCase() !== 'ALL') {
                    filteredData = mutableData.filter(data => (data.category.toUpperCase() === filterValue.toUpperCase()))
                } else {
                    filteredData = mutableData;
                }
                newState.category = filterValue;
                break;
            case 'createdDate':
                if (filterValue.toUpperCase() !== 'ALL') {
                    switch (filterValue) {
                        case 'today':
                            filteredData = mutableData.filter(x => x.createdDate.split('-')[2] === day);
                            break;
                        case 'week':
                            filteredData = mutableData.filter(x => x.createdDate.split('-')[2] <= day && x.createdDate.split('-')[2] >= day - 7);
                            break;
                        case 'month':
                            filteredData = mutableData.filter(x => x.createdDate.split('-')[1] === month);
                            break;
                        case 'year':
                            filteredData = mutableData.filter(x => x.createdDate.split('-')[0] === year.toString());
                            break;
                        default:
                            filteredData = mutableData;
                            break;
                    }
                } else {
                    filteredData = mutableData;
                }
                newState.createdDate = filterValue;
                break
            case 'requestType':
                if (filterValue.toUpperCase() !== 'ALL') {
                    filteredData = mutableData.filter(data => (data.requestType.toUpperCase() === filterValue.toUpperCase()));
                } else {
                    filteredData = mutableData;
                }
                newState.requestType = filterValue;
                break;
            case 'requestStatus':
                if (filterValue.toUpperCase() !== 'ALL') {
                    filteredData = mutableData.filter(data => (data.requestStatus.toUpperCase() === filterValue.toUpperCase()));
                } else {
                    filteredData = mutableData;
                }
                newState.requestStatus = filterValue;
                break;
            default:
                filteredData = mutableData;
                break;
        }
        setData({
            ...data,
            DP_filter: newState
        })
        setData({
            ...data,
            DP_data: filteredData,
        })

    }

    const resetFilter = () => {
        setData({
            ...data,
            DP_filter: {
                requestType: 'all',
                createdDate: 'all',
                category: 'all',
                requestStatus: 'ALL'
            },
            DP_data: data.DP_initialData
        })
    }

    return (
        <div className="container">
            <div className="dashboard">
                <div className="dashboard-pelayanan-container">
                    <div className="page-title">
                        DASHBOARD
                    </div>
                    <div className="line-space"/>
                    <div className="dashboard-section-2-title">
                        <div className="header-title">
                            Data Pendaftar Kartu
                        </div>
                        <div/>
                        <div className="header-title">
                            Status Layanan Kartu
                        </div>
                    </div>
                    <div className="dashboard-section-2">
                        <div className="dashboard-data-pendaftar-kartu">
                            <div className="dpk-container">
                                <div className="dpk-pile-container">

                                    <div className={selectedClassName('NEW')}
                                         onClick={() => onChangeDPKPile('NEW')}>Kartu
                                        Baru
                                    </div>
                                    <div className={selectedClassName('BROKEN')}
                                         onClick={() => onChangeDPKPile('BROKEN')}>Kartu
                                        Rusak
                                    </div>
                                    <div className={selectedClassName('LOST')}
                                         onClick={() => onChangeDPKPile('LOST')}>Kartu
                                        Hilang
                                    </div>

                                    <select className="dpk-pile-unselected dpk-selection" name="interval" id="interval"
                                            value={data.DPK_interval}
                                            onChange={(e) => onChangeDPKInterval(e.target.value)}>
                                        {FILTER_INTERVAL_DPK.map((item, index) => {
                                            return (
                                                <option key={item.value} value={item.value}>{item.name}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="dpk-chart-container">
                                    <Bar data={DashboardChartData(data.DPK_data.label, data.DPK_data.data)}
                                         width={80}
                                         height={50}
                                         options={{maintainAspectRatio: false}}/>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard-status-layanan-kartu">
                            {data.loginInfo === 'pelayanan'
                                ?
                                <div className="slk-container">
                                    {dataContext.totalCardCounter ? (dataContext.totalCardCounter.map((item, index) => {
                                            return (
                                                <div>
                                                    <SlkPile icons={mapSLKPile('icon', Object.keys(item))}
                                                             title={translateRequestStatus(Object.keys(item))}
                                                             number={Object.values(item)}/>
                                                    <div className="line-space"/>
                                                </div>
                                            )
                                        }))
                                        : null}
                                </div>
                                :
                                <div className="slk-container">
                                    <SlkPile icons={icPrint} title={'Kartu sudah dicetak'} number={'400'}/>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="dashboard-daftar-pelanggan">
                        <div className="header-title">
                            Daftar Pelanggan
                        </div>
                        <div className="dp-container">
                            <div className="dp-pile-container">
                                <select name="dp-layanan" id="requestType" className="dp-pile"
                                        value={data.DP_filter.requestType}
                                        onChange={(e) => onChangeDPFilter(e.target.id, e.target.value)}>
                                    {FILTER_JENIS_LAYANAN.map((item, index) => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </select>
                                <select name="dp-layanan" id="createdDate" className="dp-pile"
                                        value={data.DP_filter.createdDate}
                                        onChange={(e) => onChangeDPFilter(e.target.id, e.target.value)}>
                                    {FILTER_INTERVAL.map((item, index) => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </select>
                                <select name="dp-filter-category" id="category" className="dp-pile"
                                        value={data.DP_filter.category}
                                        onChange={(e) => onChangeDPFilter(e.target.id, e.target.value)}>
                                    {FILTER_JENIS_PENGGUNA_LAYANAN.map((item, index) => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </select>

                                <select name="dp-filter-status" id="requestStatus" className="dp-pile"
                                        value={data.DP_filter.requestStatus}
                                        onChange={(e) => onChangeDPFilter(e.target.id, e.target.value)}>
                                    {FILTER_STATUS.map((item, index) => {
                                        return (
                                            <option key={item.value} value={item.value}>{item.name}</option>
                                        )
                                    })}
                                </select>
                                <input type="text" className="dp-pile dp-search"
                                       placeholder="Cari Nama/NIK/No. Telepon"
                                       value={data.DP_search}
                                       onChange={(e) => setData({...data, DP_search: e.target.value})}
                                       onKeyDown={onSearchDaftarPelanggan}
                                />
                            </div>
                            <div className="v-spacer"/>
                            <div className="dp-pile" onClick={() => resetFilter()}>
                                Clear Filter
                            </div>
                            <div className="dp-table-container">
                                <DataTable
                                    responsive={false}
                                    pagination
                                    columns={TableColumnHeaderMapping}
                                    data={data.DP_data}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardPelayanan;
